import React, {useEffect, useState} from "react";
import StakeCard from "./StakeCard";
import styled from "styled-components";

const StakeToggleCard = ({
                             setOpenProjectView,
                             stakeId,
                             name,
                             setOpenDeleteModal,
                             setOpenEditModal,
                             children,
                             openProjectView,
                             setSelectedStakeId,
                             selectedStakeId,
                             openEditModal,
                         }) => {

    const [toggle, setToggle] = useState(false)

    useEffect(() => {
        if (selectedStakeId === stakeId) {
            setToggle(true)
        }
    }, [selectedStakeId, stakeId])

    const displayProjects = (e) => {
        setSelectedStakeId(stakeId)
        if (e.target.tagName === "svg" || e.target.tagName === "path") return
        setToggle(!toggle)
    }

    return (
        <WrapperContainer>
            <StakeCard
                name={name}
                stakeId={stakeId}
                setOpenDeleteModal={setOpenDeleteModal}
                openProjectView={openProjectView}
                setOpenProjectView={setOpenProjectView}
                setOpenEditModal={setOpenEditModal}
                toggle={toggle}
                displayProjects={displayProjects}
                openEditModal={openEditModal}
            />
            {toggle ? children : ""}
        </WrapperContainer>
    )
}

const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
  overflow: unset;
`


export default StakeToggleCard